import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-image-viewer-dialog",
  templateUrl: "./image-viewer-dialog.component.html",
  styleUrls: ["./image-viewer-dialog.component.scss"]
})
export class ImageViewerDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ImageViewerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { url: string }
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
